export default __webpack_public_path__ + "static/media/search_icon.57c94cc8.svg";